import React from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import { useHistory } from 'react-router-dom';
import ErrorPage from './ui/ErrorPage';
export default function ErrorBoundary({ children, onReset, onError }) {
    const history = useHistory();
    function handleError(error, info) {
        /*
        console.error('error: ', error);
        console.erro('info: ', info);
        */
        // we can call Sentry here
        if (onError) {
            onError();
        }
    }
    function handleReset(props) {
        if (onReset) {
            onReset();
        }
        history.push('/');
    }
    return (React.createElement(ReactErrorBoundary, { FallbackComponent: ErrorPage, onReset: handleReset, onError: handleError }, children));
}
